var countErrorFields = 0,
submitYourPolicyForm = false,
yourPolicySubmitAttempted = false,
checkedYourPolicyForm = false,
yourPolicyQuoteStartDate = $('.about__start_date .quote-question__input').val(),
yourPolicyQuoteStartDateUpdated = false;
yourPolicyValidateStartDate = true,
licenceNumberValid = {};

function getQueryVariable(variable) {
    var query = window.location.search.substring(1); // Remove the "?" at the start
    var vars = query.split("&");
    for (var i = 0; i < vars.length; i++) {
        var pair = vars[i].split("=");
        if (decodeURIComponent(pair[0]) === variable) {
            return decodeURIComponent(pair[1]);
        }
    }
    return null; // Return null if the variable is not found
}

function getCookieValue(cookieName) {
	var name = cookieName + "=";
	var decodedCookie = decodeURIComponent(document.cookie);
	var cookieArray = decodedCookie.split(";");

	for (var i = 0; i < cookieArray.length; i++) {
		var cookie = cookieArray[i].trim();
		if (cookie.indexOf(name) == 0) {
			return cookie.substring(name.length, cookie.length);
		}
	}
	return "";
}

window.validateForm = function(form) {
    $(".validation_error").remove();
    $(".error-input").removeClass("error-input");

    // Define a set of variables needed throughout validation
    const formEntries = form.find(".quote-question__wrapper > .quote-question:not(.quote-question--hidden) [data-required='true']:not([readonly]), .quote-question--sub > .quote-question [data-required='true']:not([readonly])"),
        formEntriesUnderColumns = form.find(".quote-question__wrapper > .l__row > .l__col > .l__col > .quote-question:not(.quote-question--hidden) [data-required='true']:not([readonly])"),
        childFormEntries = form.find(".quote-question__wrapper > .quote-question--children-wrapper .quote-question--children.active > .quote-question:not(.quote-question--hidden) [data-required='true']:not([readonly])"),
        aggregatorEntries = form.find(".quote-question__wrapper > .content-your-details .quote-question:not(.quote-question--hidden) [data-required='true']:not([readonly])");

    countErrorFields = 0;

    // Remove previous form errors
    form.removeClass("error");

    // Validate top-level questions
    if(formEntries.length) {
        countErrorFields += validateEntries(formEntries, countErrorFields).countErrorFields;
    }

    if(formEntriesUnderColumns.length) {
        countErrorFields += validateEntries(formEntriesUnderColumns, countErrorFields).countErrorFields;
    }

    if(childFormEntries.length) {
        countErrorFields += validateEntries(childFormEntries, countErrorFields).countErrorFields;
    }

    if(aggregatorEntries.length) {
        countErrorFields += validateEntries(aggregatorEntries, countErrorFields).countErrorFields;
    }

    window.mwConsoleLog(`Count Error Fields: ${countErrorFields}`);

    if (countErrorFields === 0) {
        return true;
    } else {
        form.addClass("error");
        return false;
    }
}

function wait() {
	var deferred = jQuery.Deferred();
	setTimeout(function () {
		deferred.resolve();
	}, 600);

	return deferred.promise();
}

function validateEntries(entries, countErrorFields = 0, dynamicValidate = false) {
    var formValid = true;
    var passCount = 0;
    var passMatch = false;
    var emailMatch = false;
    var returnData = [];
    var licenceNumberStatus = true;

    for (let i = 0; i < entries.length; i++) {
        let valItem = entries[i];
        let node = valItem.nodeName;
        let valid = { status: true, message: '' };
        let msg = '';

        if (node === "INPUT") {
            valid = validateInput(valItem, dynamicValidate);

            if (valItem.classList.contains('license-first')) {
                licenceNumberValid['license-first'] = valid;
            }
            if (valItem.classList.contains('license-second')) {
                licenceNumberValid['license-second'] = valid;
            }
            if (valItem.classList.contains('license-third')) {
                licenceNumberValid['license-third'] = valid;
            }


            if (valid && valid.message) {
                msg = valid.message;
            }

            if (valid && valid.type === "password" && !$(valItem).hasClass('payment__code--input')) {
                ({ passCount, passMatch, valid, msg } = handlePasswordValidation(valItem, passCount, passMatch, valid, msg));
            }

            if (valid && valid.type === "email") {
                ({ emailMatch, valid, msg } = handleEmailValidation(valItem, emailMatch, valid, msg));
            }

        } 
        // PATCH: Handle Select2 as visible
        else if (node === "SELECT" && (isVisible(valItem) || $(valItem).hasClass('select2-hidden-accessible'))) {
            valid = validateSelect(valItem);
            msg = valid.message;
        } 
        else if (node === "TEXTAREA" && isVisible(valItem)) {
            valid = validateTextarea(valItem);
            msg = valid.message;
        }

        // Licence fields handling...
        if (valItem.classList.contains('license-first')) {
            if (licenceNumberValid['license-first'].status === true) {
                markAsCorrect(valItem);
            } else {
                msg = licenceNumberValid['license-first'].message;
                countErrorFields = insertValidation(valItem, msg, countErrorFields, dynamicValidate);
                formValid = false;
            }
        } else if (valItem.classList.contains('license-second')) {
            if (licenceNumberValid['license-second'].status === true) {
                markAsCorrect(valItem);
            } else {
                msg = licenceNumberValid['license-second'].message;
                countErrorFields = insertValidation(valItem, msg, countErrorFields, dynamicValidate);
                formValid = false;
            }
        } else if (valItem.classList.contains('license-third')) {
            if (licenceNumberValid['license-third'].status === true) {
                markAsCorrect(valItem);
            } else {
                msg = licenceNumberValid['license-third'].message;
                countErrorFields = insertValidation(valItem, msg, countErrorFields, dynamicValidate);
                formValid = false;
            }
        } else {
            if (valid && !valid.status) {
                countErrorFields = insertValidation(valItem, msg, countErrorFields, dynamicValidate);
                formValid = false;
            } else {
                markAsCorrect(valItem);
            }
        }

        $.each(licenceNumberValid, function (key, value) {
            if (value.status === false) {
                licenceNumberStatus = false;
                return false;
            }
        });

        if (
            licenceNumberStatus === false &&
            (valItem.classList.contains('license-first') ||
             valItem.classList.contains('license-second') ||
             valItem.classList.contains('license-third'))
        ) {
            msg = msg ? msg : "Please make sure all licence number fields are filled in correctly";
            countErrorFields = insertValidation(valItem, msg, countErrorFields, dynamicValidate);
            formValid = false;
        }
    }

    if (!formValid && dynamicValidate) {
        entries.closest('.quote-question.input-status--correct')
               .removeClass('input-status--correct')
               .addClass('input-status--incorrect');
    }

    returnData['formValid'] = formValid;
    returnData['countErrorFields'] = countErrorFields;

    return returnData;
}

function removeValidation(valItem) {
    var parent = valItem.closest('.quote-question');

    parent.removeClass("error input-status input-status--incorrect input-status--correct");
}

function validateInput(valItem, dynamicValidate = false) {
    let valid = { status: true, message: '', type: '' };

    if (valItem.getAttribute("type") !== "email") {

        if (valItem.classList.contains('dob') && isVisible(valItem)) {
            valid = handleDateInput(valItem, true);
        } else if(valItem.getAttribute("type") === "text" && isVisible(valItem) && isNameInput(valItem) && !isInputReadonly(valItem)) {
            valid = handleName(valItem);
        } else if(valItem.getAttribute("type") === "text" && isVisible(valItem) && isUsername(valItem) && !isInputDisabled(valItem) && !isInputReadonly(valItem)) {
            valid = handleUsername(valItem, dynamicValidate);
        } else if(valItem.getAttribute("type") === "text" && isVisible(valItem) && isUsername(valItem) && (isInputDisabled(valItem) || isInputReadonly(valItem))) {
            window.mwConsoleLog('Username input is disabled or readonly, skipping validation and setting submitYourPolicyForm=true.');
            submitYourPolicyForm = true;
        } else if (valItem.getAttribute("data-expiry-date") && $(valItem).hasClass('card-expiry-date')) {
            valid = handleExpiryDate(valItem);
        } else if (valItem.getAttribute("data-type") === "cvv" && $(valItem).hasClass('payment__code--input')) {
            valid = handleSecurityCode(valItem);
        } else if (valItem.getAttribute("type") === "text" && isVisible(valItem) && !isPasswordOrConfirm(valItem)) {
            valid = handleTextInput(valItem);
        } else if (valItem.getAttribute("type") === "number" && isVisible(valItem)) {
            valid = handleNumberInput(valItem);
        } else if (valItem.getAttribute("type") === "date" && isVisible(valItem)) {
            valid = handleDateInput(valItem);
        } else if (valItem.getAttribute("type") === "datetime-local" && isVisible(valItem)) {
            valid = handleDateInput(valItem);
        } else if (valItem.getAttribute("type") === "file") {
            valid = handleFileInput(valItem);
        } else if (valItem.getAttribute("type") === "checkbox" && !$(valItem).hasClass('quote-tooltip__input')) {
            // check if the first parent is in fact opened.
            if(
                $(valItem).hasClass("skip") || 
                ($(valItem).parents('.quote-question--children').length && !$(valItem).parents('.quote-question--children').last().hasClass('active'))
            ) {
                valid.status = true;
            } else {
                valid = handleCheckboxInput(valItem);
            }
        } else if (valItem.getAttribute("type") === "radio" && !$(valItem).hasClass('quote-tooltip__input')) {
            // check if the first parent is in fact opened.
            if($(valItem).parents('.quote-question--children').length && !$(valItem).parents('.quote-question--children').last().hasClass('active')) {
                valid.status = true;
            } else {
                valid = handleRadioInput(valItem);
            }
        } else if (isPasswordOrConfirm(valItem)) {
            valid.type = "password";
        } else if (valItem.getAttribute("type") === "hidden") {
            valid = handleHiddenInput(valItem);
        }
    } else {
        valid = handleEmailInput(valItem);
        valid.type = "email";
    }

    return valid;
} 

function validateCharactersOnly(valItem) {
    var regex = /^[A-Za-z -]+$/; // Regular expression to match only alphabetic characters

    // Test the input value against the regular expression
    return regex.test(valItem);
}

function validateName(valItem) {
    var regex = /^[a-zA-Z'\s-]+$/; // Only these characters allowed, and must fill the whole string

    // Test the input value against the regular expression
    return regex.test(valItem);
}

function handleName(valItem) {
    let valid = { status: true, message: '', type: '' },
    isValidName = validateName(valItem.value);

    if(!isValidName) {
        valid.status = false;
        valid.message = "Please make sure that the name contains letters and allowed characters. (allowed characters: space and - and ')";
    }

    // Strip all spaces and check if anything remains
    const stripped = valItem.value.replace(/\s/g, '');
    if (stripped.length < 1) {
        valid.status = false;
        valid.message = "Please enter a name with at least 1 non-space character.";
    }

    return valid;
}

function handleUsername(valItem, dynamicValidate = false) {
    var animPromise,
	ajaxPromise,
	pathArray = location.href.split("/"),
	protocol = pathArray[0],
	host = pathArray[2],
	ajax_url = protocol + "//" + host + "/wp-admin/admin-ajax.php",
    result,
    valid = { status: true, message: '' },
    value = valItem.value,
    customerID = $(document).find('input[name=details__customer_id]').val();

    if(value.includes(' ')) {
        valid.message = 'This username contais spaces, please remove them.';
        valid.status = false;
        insertValidation(valItem, valid.message, 0, false);

        return valid;
    }

    animPromise = wait();
    ajaxPromise = $.ajax({
        type: "POST",
        url: ajax_url,
        dataType: "json",
        data: {
            action: "mw_ajax_validate_username",
            username: valItem.value,
            customerID : customerID,
        },
        success: function (data) {
            result = data;
        },
        error: function(xhr, status, error) {
            console.error("Error occurred during AJAX request - status code:", xhr.status);
            console.error("Error occurred during AJAX request - message:", error);
        },
        complete: function() {
            window.mwConsoleLog("AJAX request complete.");
        }
    });
    $.when(animPromise, ajaxPromise).done(function () {
        let success = true;

        window.mwConsoleLog(`countErrorFields: ${countErrorFields}`);
        window.mwConsoleLog(`SubmitYourPolicyForm: ${submitYourPolicyForm}`);
        window.mwConsoleLog(`Dynamic Validate: ${dynamicValidate}`);
        window.mwConsoleLog(`Username validation result: ${result}`);

        if (result && result != '[]' && result.length) {
            // eslint-disable-next-line
            let decodedResult = JSON.parse(result.replace(/\u0004/g, ""));
            if(decodedResult && decodedResult.UsernameAvailable == false) {
                success = false;
            }
        } else {
            success = false;
        }

        // if the AJAX query wasn't successful, then show error.
        if(!success) {
            valid.message = 'This username is not unique, please enter a different username.';
            valid.status = false;
            insertValidation(valItem, valid.message, 0, false);
        } else if(countErrorFields == 0 && !submitYourPolicyForm && !dynamicValidate) {
            window.mwConsoleLog('Username is valid, setting submitYourPolicyForm=true and resubmitting form.');
            submitYourPolicyForm = true;

            $(valItem).closest('form').trigger('submit');
        } else if(countErrorFields == 0 && !submitYourPolicyForm) {
            window.mwConsoleLog('Username is valid, setting submitYourPolicyForm=true');
            submitYourPolicyForm = true;

            if (yourPolicySubmitAttempted) {
                window.mwConsoleLog('Submit was previously attempted — resubmitting form now.');
                $(valItem).closest('form').trigger('submit');
            }
        }

        return valid;
    });
}

function handlePasswordValidation(valItem, passCount, passMatch, valid, msg) {
    if(valItem.value.length == 0) {
        valid.status = false;
        msg = "Please enter a value";
    } else if (valItem.getAttribute("name") === "cvv" || valItem.getAttribute("data-type") === "cvv") {
        valid = validateCVV(valItem);
        msg = valid.message;
    } else {
        if (passCount === 0 && valid.status) {
            passMatch = valItem.value;
            passCount++;
        }

        if (passCount >= 1 && valid.status) {
            valid.status = passMatch === valItem.value;
            msg = "Passwords do not match";
        }

        
        if(valItem.getAttribute("data-type") !== "login-password") {
            if(valid.status) {  
                /*
                    •	At least 8 characters
                    •	At least one lowercase letter
                    •	At least one uppercase letter
                    •	At least one digit
                    •	At least one special character
                */

                // TODO: keep a record of old password regex
                const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[~`!@#$%^&*()\-_+={}[\]|\\:;"'<>,.?/£])[A-Za-z\d~`!@#$%^&*()\-_+={}[\]|\\:;"'<>,.?/£]{8,}$/;

                // avoid issues with escaping characters in the regex by defining the special characters separately and including them in the regex.
                // const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[~`!@#$%^&*()\-_+={}[\]|:;'<>?,.£])[A-Za-z\d~`!@#$%^&*()\-_+={}[\]|:;'<>?,.£]{8,}$/;

                if (!passwordRegex.test(valItem.value)) {
                    valid.status = false;
                    msg = "Password is not strong enough. Please make sure you password is at least 8 characters long, contains one lowercase letter, one uppercase letter, one digit and one special character.";
                }
            }
        }
    }
    
    return { passCount, passMatch, valid, msg };
}

function handleEmailValidation(valItem, emailMatch, valid, msg) {
    if (valid.status && valItem.getAttribute("name") != "confirm_email") {
        emailMatch = valItem.value;
    }

    if(valid.status && !emailMatch){
        var emailInput = $(valItem).closest('form').find('input[type=email]:not([name=confirm_email])'); 

        if(emailInput.length){
            emailMatch = $(emailInput).val();
        }
    }

    if (valid.status && valItem.getAttribute("name") === "confirm_email" && emailMatch !== valItem.value) {
        valid.status = false;
        msg = "Emails do not match";
    }

    return { emailMatch, valid, msg };
}

function handleCustomSelectValidation(valItem) {
	var valid = { status: true, message: "" };
	var selectName = 'select[name="' + valItem.getAttribute("name") + '"]';

    if(valItem.getAttribute("name")) {
        // handle custom validation for Automatic Licence Type on Automatic Car.
        if (valItem.getAttribute("name").includes("details__license_type")) {
            if($('input[name=prefill-transmission_type]').data('value') == 'AUTOMATIC') {
                if ($(selectName).val() == '2') {
                    valid.message = "You are unable to proceed with the selection made.";
                    valid.status = false;

                    if (!$("#automatic_licence_error_message").is(":visible")) {
                        lity("#automatic_licence_error_message");
                    }
                }
            }
        }
    }

    return valid;
}

function validateSelect(valItem) {
    let valid = { status: true, message: '' };

    // Check if this select is a Select2
    let isSelect2 = $(valItem).hasClass('select2-hidden-accessible');

    // Handle special wrapper for car registration
    if ($(valItem).closest('.car__registration-manual-wrapper').length) {
        let parent = $(valItem).closest('.car__registration-manual-wrapper');
        if (parent.hasClass('active')) {
            valid.status = (valItem.value && valItem.value.trim().length >= 1);
            valid.message = "Please select from one of the options";
        }
    } else {
        // For normal or Select2, check if there's a selected value
        if(!valItem.getAttribute("name").includes("--proxy")) {
            valid.status = (valItem.value && valItem.value.trim().length >= 1);
            valid.message = "Please select from one of the options";
        }
    }

    // Run any custom select validation regardless of Select2 state
    let customValidation = handleCustomSelectValidation(valItem);
    if (!customValidation.status) {
        valid = customValidation;
    }

    // If Select2, also handle placeholder case (no selection made)
    if (
        isSelect2 && 
        (!valItem.value || valItem.value === "") && 
        !valItem.getAttribute("name").includes("--proxy")
    ) {
        let select2Container = $(valItem).next('.select2-container').find('.select2-selection');

        if(isVisible(select2Container, true)) {
            valid.status = false;
            valid.message = "Please select from one of the options";
        } else {
            valid.status = true; // If not visible, we assume it's not required
        }
    }

    if(!valid.status) {
        window.mwConsoleLog(`Select validation for ${valItem.name}: false, message: ${valid.message}, isSelect2: ${isSelect2}, value: ${valItem.value}`);
    }

    return valid;
}

function validateTextarea(valItem) {
    let valid = { status: valItem.value.length >= 1, message: "Please enter a value" };
    return valid;
}

function handleExpiryDate(valItem) {
    let valid = { status: true, message: '' };

    valid = validateExpiryDate(valItem);

    return valid;
}

function handleTextInput(valItem) {
    let valid = { status: true, message: '' };

    if (valItem.getAttribute("data-type") === "postcode") {
        valid = validatePostcode(valItem);
    } else if (valItem.getAttribute("data-license-number") === "true") {
        valid = validateLicenseNumber(valItem);
    } else if (valItem.getAttribute("data-phone") === "true") {
        valid = validatePhoneNumber(valItem);
    } else if (valItem.getAttribute("data-card-number") === "true") {
        valid = validateCardNumber(valItem);
    } else if (valItem.getAttribute("data-expiry-date") === "true") {
        valid = validateExpiryDate(valItem);
    } else {
        valid.status = valItem.value.trim().length >= 1;
        valid.message = "Please enter a value";
    }

    return valid;
}

function validateLicenseNumber(valItem) {
    let valid = { status: true, message: '' };

    if (valItem.value.length < 1) {
        valid.status = false;
        if (valItem.classList.contains('license-first')) {
            valid.message = "Please make sure the first section of the licence number is filled in";
        } else if (valItem.classList.contains('license-second')) {
            valid.message = "Please make sure the second section of the licence number is filled in";
        } else if (valItem.classList.contains('license-third')) {
            valid.message = "Please make sure the third section of the licence number is filled in";
        } else {
            valid.message = "Please make sure each section of the licence number is filled in";
        }
    } else {
        if (valItem.classList.contains('license-first')) {
            let re = /^[a-zA-Z]{3}[a-zA-Z9]{2}$/;
            if (!re.test(valItem.value)) {
                valid.status = false;
                valid.message = "Please make sure the first section of the licence number is exactly 5 letters or numbers where the last 2 can be number 9";
            }
        } else if (valItem.classList.contains('license-second')) {
            let re = /^\d{6}$/;
            if (!re.test(valItem.value)) {
                valid.status = false;
                valid.message = "Please make sure the second section of the licence number is exactly 6 numbers";
            }
        } else if (valItem.classList.contains('license-third')) {
            let re = /^[a-zA-Z\d]{5}$/;
            if (!re.test(valItem.value)) {
                valid.status = false;
                valid.message = "Please make sure the third section of the licence number is exactly 5 characters";
            }
        }
    }

    return valid;
}

function validatePostcode(valItem) {
    let valid = { status: true, message: '' };
    let postcodeVal = valItem.value.replace(/\s/g, "");

    // Regular expression for validating UK postcode
    let regexCheck = /^([Gg][Ii][Rr] 0[Aa]{2})|((([A-Za-z][0-9]{1,2})|(([A-Za-z][A-Ha-hJ-Yj-y][0-9]{1,2})|(([A-Za-z][0-9][A-Za-z])|([A-Za-z][A-Ha-hJ-Yj-y][0-9][A-Za-z]?))))\s?[0-9][A-Za-z]{2})$/;

    if (postcodeVal.length > 7) {
        valid.status = false;
        valid.message = "Please enter a valid postcode.";
    } else if (!postcodeVal.match(regexCheck)) {
        valid.status = false;
        valid.message = "Please enter a valid postcode.";
    }

    return valid;
}

function validatePhoneNumber(valItem) {
    let valid = { status: true, message: '' };
    let phoneNumber = valItem.value.replace(/\s/g, "");

    // Regular expression for validating phone number
    let regexCheck = /^07\d{9}$/;

    if (!regexCheck.test(phoneNumber)) {
        valid.status = false;
        valid.message = "Please enter a valid number";
    }

    return valid;
}

function validateCardNumber(valItem) {
    let valid = { status: true, message: '' };

    if (valItem.value.length < 1) {
        valid.status = false;
        valid.message = "Please make sure to enter a card number";
    } else if (!validateLuhnAlgorithm(valItem.value)) {
        valid.status = false;
        valid.message = "Please make sure to enter a correct card number";
    }

    return valid;
}

function validateExpiryDate(valItem) {
    let valid = { status: true, message: '' };

    if (!valItem.value || valItem.value.length < 1) {
        valid.status = false;
        valid.message = "Please make sure to select an expiry date";
    } else if (!validateExpirationDate(valItem.value)) {
        valid.status = false;
        valid.message = "Please make sure to enter a correct expiry date";
    }

    return valid;
}

function handleNumberInput(valItem) {
    let valid = { status: valItem.value.length >= 1, message: "Please enter a number" };

    if (valItem.getAttribute("min") && valItem.value < parseInt(valItem.getAttribute("min"))) {
        valid.status = false;
        valid.message = "Minimum value of " + valItem.getAttribute("min");
    }

    if (valItem.getAttribute("max") && valItem.value > parseInt(valItem.getAttribute("max"))) {
        valid.status = false;
        valid.message = "Maximum value of " + valItem.getAttribute("max");
    }

    return valid;
}

function parseUKDate(dateString) {
    if (!dateString) return null;

    // ISO format (e.g. 2026-03-24T13:17)
    if (dateString.includes('-')) {
        let date = new Date(dateString);
        return isNaN(date.getTime()) ? null : date;
    }

    // UK format (dd/mm/yyyy or mm/yyyy)
    if (dateString.includes('/')) {
        let parts = dateString.split('/');
        let day = 1, month, year;

        if (parts.length === 3) {
            day = parseInt(parts[0], 10);
            month = parseInt(parts[1], 10) - 1;
            year = parseInt(parts[2], 10);
        } else if (parts.length === 2) {
            month = parseInt(parts[0], 10) - 1;
            year = parseInt(parts[1], 10);
        } else {
            return null;
        }

        let date = new Date(year, month, day);

        if (
            date.getFullYear() !== year ||
            date.getMonth() !== month ||
            (parts.length === 3 && date.getDate() !== day)
        ) {
            return null;
        }

        return date;
    }

    return null;
}

function handleDateInput(valItem, checkRegex = false) {
    let valid = { status: valItem.value.length >= 1, message: "Please enter a date" };

    if (checkRegex) {
        // Get format from data attribute or use default
        let format = valItem.getAttribute("data-format") || 'd/m/Y';
        let parts = format.split('/');
        let lengths = [];
        let order = [];
        for (let part of parts) {
            let lower = part.toLowerCase();
            if (lower.includes('d')) {
                lengths.push(2);
                order.push('day');
            } else if (lower.includes('m')) {
                lengths.push(2);
                order.push('month');
            } else if (lower.includes('y')) {
                lengths.push(part.length === 1 ? 2 : 4);
                order.push('year');
            }
        }
        // Build regex
        let regexStr = '^';
        for (let i = 0; i < lengths.length; i++) {
            regexStr += '\\d{' + lengths[i] + '}';
            if (i < lengths.length - 1) regexStr += '\\/';
        }
        regexStr += '$';
        let datePattern = new RegExp(regexStr);
        // Override with data-regex if present
        if (valItem.getAttribute("data-regex")) {
            datePattern = new RegExp(valItem.getAttribute("data-regex"));
        }

        // First, check format with regex
        if (!datePattern.test(valItem.value)) {
            valid.status = false;
            // Dynamic message
            let formatDisplay = format.replace(/d/g, 'DD').replace(/m/g, 'MM').replace(/y/g, 'YY').replace(/Y/g, 'YYYY');
            valid.message = "Please enter a date in the correct format (" + formatDisplay + ")";
        } else {
            // Now check if it is a real date
            const inputParts = valItem.value.split('/');
            if (inputParts.length !== parts.length) {
                valid.status = false;
                valid.message = "Invalid date format";
            } else {
                let day = 1, month = 0, year = 0;
                for (let i = 0; i < order.length; i++) {
                    let val = parseInt(inputParts[i], 10);
                    if (order[i] === 'day') day = val;
                    else if (order[i] === 'month') month = val - 1;
                    else if (order[i] === 'year') year = val;
                }
                const date = new Date(year, month, day);
                let invalid = date.getFullYear() !== year || date.getMonth() !== month;
                if (order.includes('day')) {
                    invalid = invalid || date.getDate() !== day;
                }
                if (invalid) {
                    valid.status = false;
                    valid.message = "Please enter a valid date";
                }
            }
        }
    }

    if(valid.status) {
        if (valItem.getAttribute("data-min") && valItem.value.length) {
            if (valItem.getAttribute("name").includes("about__start_date")) {
                // if it hasn't been previously initialised, do it once.
                if(!yourPolicyQuoteStartDate) {
                    yourPolicyQuoteStartDate = valItem.value;
                }

                // if the value has ever changed, then mark it.
                if(valItem.value != yourPolicyQuoteStartDate) {
                    valItem.setAttribute("data-value-changed", "true");
                }
            }

            var now = new Date(),
            currentDate = new Date(now.getTime()),
            date = parseUKDate(valItem.value),
            minDate = parseUKDate(valItem.getAttribute("data-min")),
            minDateCheck = parseUKDate(valItem.getAttribute("data-min")),
            startTime = parseUKDate(valItem.getAttribute("data-start-time")),
            startTimeCheck = parseUKDate(valItem.getAttribute("data-start-time")),
            startTimeMaxCheck = parseUKDate(valItem.getAttribute("data-start-time")),
            previouslyAltered = valItem.getAttribute("data-value-changed");

            // dynamically adjust the [data-min] attribute for [Quote Start Date] input.
            if(previouslyAltered) {
                if (valItem.getAttribute("name").includes("about__start_date")) {
                    var now = new Date(),
                    // currentDate = new Date(now.getTime() + 10 * 60000), // appent 10 minutes to the current date.
                    currentDate = new Date(now.getTime()),
                    year = currentDate.getFullYear(),
                    month = String(currentDate.getMonth() + 1).padStart(2, '0'),
                    day = String(currentDate.getDate()).padStart(2, '0'),
                    hours = String(currentDate.getHours()).padStart(2, '0'),
                    minutes = String(currentDate.getMinutes()).padStart(2, '0'),
                    formattedTimestamp = `${year}-${month}-${day} ${hours}:${minutes}`;
            
                    valItem.setAttribute('data-min', formattedTimestamp);
                    previouslyAltered = false;
                }
            }

            if(minDateCheck) {
                minDateCheck.setMinutes(minDateCheck.getMinutes() + 10); // normal validation will need the 10 minutes in the future flag.
            }

            if(startTimeCheck) {
                startTimeCheck.setMinutes(startTimeCheck.getMinutes() + 5); // allow up to 5 minutes of time being spent on the page prior to validating.
            }

            if(startTimeMaxCheck) {
                startTimeMaxCheck.setMinutes(startTimeMaxCheck.getMinutes() + 15); // total allowance is minimum of 10 minutes + the additional buffer time. 
            }

            if(date) {
                date.setSeconds(0, 0);
            }

            if(minDate) {
                minDate.setSeconds(0, 0);
            }

            if(currentDate) {
                currentDate.setSeconds(0, 0);
            }

            if (valItem.getAttribute("name").includes("about__start_date")) {
                if(date.getTime() < currentDate.getTime()) {
                    valid.status = false;
                    const readableDate = minDate.toLocaleDateString();
            
                    if (valItem.getAttribute("name").includes("about__start_date")) {
                        valid.message = "The start date cannot be in the past";
                    } else {
                        valid.message = "Earliest date " + readableDate;
                    }
                }
            } else {
                if(date.getTime() < minDate.getTime()) {
                    valid.status = false;
                    const readableDate = minDate.toLocaleDateString();
            
                    if (valItem.getAttribute("name").includes("about__start_date")) {
                        valid.message = "The start date cannot be in the past";
                    } else {
                        valid.message = "Earliest date " + readableDate;
                    }
                }
            }
        }

        if (valItem.getAttribute("data-max") && valItem.value.length) {
            var date = parseUKDate(valItem.value);
            var max = parseUKDate(valItem.getAttribute("data-max"));

            if(date.getTime() > max.getTime()){
                valid.status = false;

                const readableDate = max.toLocaleDateString();
                valid.message = "Maximum date " + readableDate;

                if(valItem.getAttribute("type") == "datetime-local"){
                    const readableTime = max.toLocaleTimeString();
                    valid.message +=  " " + readableTime;
                }

            }
        }
    }
    

    if(valid.status) {
        if (valItem.getAttribute("name").includes("about__start_date")) {
            var quoteStartDateCompare = quoteStartDate = parseUKDate(valItem.value),
                previousHours = valItem.dataset.hours ?? '',
                previousMinutes = valItem.dataset.minutes ?? '';

            if(previousHours && previousMinutes && !yourPolicyQuoteStartDateUpdated) {
                if(parseInt(previousHours) == quoteStartDate.getHours() && parseInt(previousMinutes) == quoteStartDate.getMinutes()) {
                    quoteStartDateCompare.setHours(0, 0, 0, 0);
                    currentDate.setHours(0, 0, 0, 0);

                    // Calculate the date difference in milliseconds (1 day equals 24 hours * 60 minutes * 60 seconds * 1000 milliseconds)
                    var oneDayDifferenceInMs = 24 * 60 * 60 * 1000;
            
                    // [Quote Start] input date is in the future by at least 1 day.
                    if(quoteStartDateCompare.getTime() - currentDate.getTime() >= oneDayDifferenceInMs) {
                        // Add 1 minute to the current date and time
                        quoteStartDate.setMinutes(quoteStartDate.getMinutes() + 1);
            
                        var year = quoteStartDate.getFullYear(),
                        month = String(quoteStartDate.getMonth() + 1).padStart(2, '0'),
                        day = String(quoteStartDate.getDate()).padStart(2, '0'),
                        hours = String(quoteStartDate.getHours()).padStart(2, '0'),
                        minutes = String(quoteStartDate.getMinutes()).padStart(2, '0'),
                        formattedTimestamp = `${year}-${month}-${day} ${hours}:${minutes}`;
            
                        valItem.value = formattedTimestamp;

                        yourPolicyQuoteStartDateUpdated = true;
                    }
                }
            }

            valItem.setAttribute('data-hours', quoteStartDate.getHours());
            valItem.setAttribute('data-minutes', quoteStartDate.getMinutes());
        }
    }

    console.log(`Date validation for ${valItem.name}: ${valid.status}, message: ${valid.message}, value: ${valItem.value}`);
    console.log(`Current date: ${currentDate}, Min date: ${valItem.getAttribute("data-min")}, Max date: ${valItem.getAttribute("data-max")}`);

    return valid;
}

function handleFileInput(valItem) {
    let valid = { status: valItem.value.length >= 1, message: "Please select a file" };
    return valid;
}

function handleCheckboxInput(valItem) {
    let valid = { status: valItem.checked, message: '' };

    if (valItem.getAttribute("name") === "termsaccept" || valItem.getAttribute("data-type") === "termsaccept") {
        valid.message = "Please accept to proceed";
    } else {
        valid = handleRadioInput(valItem);
        //valid.message = "You must select this option";
    }

    return valid;
}

function handleCustomRadioValidation(valItem)
{
	var valid = { status: true, message: "" };
	var radioName = 'input[name="' + valItem.getAttribute("name") + '"]:checked';

    // handle custom validation for Additional Driver question.
	if (valItem.getAttribute("name").includes("details__additional_drivers")) {
        let car__owner_who = $('input[name=prefill-car__owner_who]'),
            car__owner_keeper = $('input[name=prefill-car__owner_keeper]');

		if ($(radioName).val() == "true" && car__owner_who.length && car__owner_keeper.length) {
            if(car__owner_who.data('value') != '1' || car__owner_keeper.data('value') != '1') {
                valid.message = "You are unable to proceed with the selection made.";
                valid.status = false;
    
                if (!$("#your_details_additional_driver_error_message").is(":visible")) {
                    lity("#your_details_additional_driver_error_message");
                }
            }
		}
	}

    // handle custom validation for the Additional Driver limit when switching from an annual to a short term policy,
    // which allows only 1 additional driver (prefilled drivers from the annual selection can exceed this).
	if (valItem.getAttribute("name") == "details__additional_drivers") {
		if ($(radioName).val() == "true") {
			// the length question lives on the your-car stage which isn't in this stage's DOM, so read the prefill mirror input.
			var learner_insurance_type_prefill = $('input[name="prefill-car__learner_insurance_type"]');
			var learner_insurance_type = learner_insurance_type_prefill.length
				? learner_insurance_type_prefill.data("value")
				: ($('input[name="car__learner_insurance_type"]:checked').val() || $('select[name="car__learner_insurance_type"]').val());
			// count the driver blocks by their name question - empty loader placeholders are appended by the
			// AJAX add without the c__loader--wrapper class, so counting the blocks themselves overcounts.
			var additional_driver_count = $(valItem).closest(".quote-question").nextAll(".quote-question--children-wrapper").first().find(".details__additional_fname").length;

			if (learner_insurance_type == "short" && additional_driver_count > 1) {
				valid.message = "You are unable to proceed with the selection made.";
				valid.status = false;

				if (!$("#your_details_short_term_driver_limit_error_message").is(":visible")) {
					lity("#your_details_short_term_driver_limit_error_message");
				}
			}
		}
	}

    // handle custom validation for Additional Driver - Vehicle question.
	if (valItem.getAttribute("name").includes("details__additional_own_other")) {
		if ($(radioName).val() == "false") {
			valid.message = "You are unable to proceed with the selection made.";
			valid.status = false;

			if (!$("#your_details_additional_driver_vehicle_error_message").is(":visible")) {
				lity("#your_details_additional_driver_vehicle_error_message");
			}
		}
	}

	// handle custom validation for Declined Insurance question.
	if (valItem.getAttribute("name").includes("about__declined")) {
		if ($(radioName).val() == "true") {
			valid.message = "You are unable to proceed with the selection made.";
			valid.status = false;

			if (!$("#declined_insurance_error_message").is(":visible")) {
				lity("#declined_insurance_error_message");
			}
		}
	}

    	// handle custom validation for Declined Insurance question.
	if (valItem.getAttribute("name").includes("details__additional_drivers_confirm")) {
		if ($(radioName).val() == "false") {
			valid.message = "You are unable to proceed with the selection made.";
			valid.status = false;

			if (!$("#your_details_additional_driver_confirm_error_message").is(":visible")) {
				lity("#your_details_additional_driver_confirm_error_message");
			}
		}
	}

	// handle custom validation for Declined Insurance question.
	if (valItem.getAttribute("name").includes("details__convictions_unspent_convictions") || valItem.getAttribute("name").includes("details__additional_convictions_unspent_convictions")) {
		if ($(radioName).val() == "true") {
			valid.message = "You are unable to proceed with the selection made.";
			valid.status = false;

			if (!$("#unspent_convictions_error_message").is(":visible")) {
				lity("#unspent_convictions_error_message");
			}
		}
	}

    // handle scenario if customer checks modifications but removes them all.
	if (valItem.getAttribute("name").includes("car__modifications")) {
        if ($(radioName).val() == "true") {
            let children = $(valItem).closest('.quote-question').next('.quote-question--children-wrapper').find('.quote-question--children:first');

            if(!children || children.find('.car__modifications_type').length == 0) {
                valid.message = "You are unable to proceed, please make sure you either toggle off modifications or add modifications.";
                valid.status = false;
            }
        }
    }

    // handle scenario if customer checks accidents but removes them all.
    if (valItem.getAttribute("name").includes("details__motor_accidents")) {
        if ($(radioName).val() == "true") {
            let children = $(valItem).closest('.quote-question').next('.quote-question--children-wrapper').find('.quote-question--children:first');

            if(!children || children.find('.details__motor_type').length == 0) {
                valid.message = "You are unable to proceed, please make sure you either toggle off accidents or add accidents.";
                valid.status = false;
            }
        }
    }

    // handle scenario if customer checks additional drivers but removes them all.
	if (valItem.getAttribute("name") == "details__additional_drivers") {
		if ($(radioName).val() == "true") {
			let children = $(valItem).closest('.quote-question').next('.quote-question--children-wrapper').find('.quote-question--children:first');

			if(!children || children.find('.details__additional_fname').length == 0) {
				valid.message = "You are unable to proceed, please make sure you either toggle off additional drivers or add an additional driver.";
				valid.status = false;
			}
		}
	}

    // handle scenario if customer checks convictions but removes them all.
    if (valItem.getAttribute("name").includes("details__convictions]") || valItem.getAttribute("name") == 'details__convictions') {
        if ($(radioName).val() == "true") {
            let children = $(valItem).closest('.quote-question').next('.quote-question--children-wrapper').find('.quote-question--children:first');

            if(!children || children.find('.details__convictions_code').length == 0) {
                valid.message = "You are unable to proceed, please make sure you either toggle off convictions or add convictions.";
                valid.status = false;
            }
        }
    }

	return valid;
}

function handleRadioInput(valItem) {
	let valid = { status: true, message: "" };
	var radioName = 'input[name="' + valItem.getAttribute("name") + '"]';
	var checked = false;
	var parent = $(radioName).closest(".quote-question--children");
    
    // Trigger custom validation.
    valid = handleCustomRadioValidation(valItem);

	if ($(radioName).length) {
		// loop through inputs
		$.each($(radioName), function (index, radio) {
			// if the current radio input is a direct child.
			if (parent.length && !$(parent).hasClass("active")) {
				// skip the current radio input.
				return valid;
			}

			if (radio.checked || checked === true) {
				checked = true;
				return valid;
			}
		});

		if (!checked) {
            if((parent.length && $(parent).hasClass("active")) || !parent.length) {
                valid.message = "You must select at least one option";
                valid.status = false;
            }
		}
	}

	return valid;
}

function handleSecurityCode(valItem) {
    let valid = { status: true, message: '' };

    if (valItem.getAttribute("data-required")) {
        if ( isVisible(valItem) ) {
            valid.status = valItem.value && valItem.value.length && valItem.value.length == 3;
            valid.message = "Please enter a valid security code";
        }
    }

    return valid;
}

function handleHiddenInput(valItem) {
    let valid = { status: true, message: '' };

    if (valItem.getAttribute("data-required") && valItem.nextSibling.classList.contains("form-control")) {
        if ( isVisible(valItem) ) {
            valItem = valItem.nextSibling;
            valid.status = valItem.value.trim().length >= 1;
            valid.message = "Please enter a date";
        }
    }

    return valid;
}

function handleEmailInput(valItem) {
    let valid = { status: valItem.value.length >= 1, message: "Please enter a value" };

    if (valid.status) {
        let emReg = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        valid.status = emReg.test(valItem.value);
        valid.message = "Please enter a valid email";
    }

    return valid;
}

function markAsCorrect(valItem) {
    $(valItem).closest('.quote-question').addClass("input-status").addClass("input-status--correct").removeClass("input-status--incorrect");
    $(valItem).removeClass('error-input');
    $(valItem).siblings('.validation_error').remove();
}

function isVisible(valItem, isObject = false) {
    if (isObject) {
        if (!valItem.is(':visible')) return false;

        if (valItem.css('display') == 'none') return false;

        if (valItem.css('visibility') == 'hidden') return false;

        if (valItem.css('opacity') == '0') return false;

        if (valItem.css('width') == '0' && valItem.css('height') == '0') return false;

        // Check tabindex attribute
        const tabindex = valItem.attr('tabindex');
        if (tabindex !== undefined && tabindex === '-1') return false;

    } else {
        if (!valItem) return false;

        const style = window.getComputedStyle(valItem);

        if (!$(valItem).is(':visible')) return false;

        if (style.display == 'none') return false;

        if (style.visibility == 'hidden') return false;

        if (style.opacity == '0') return false;

        if (style.width == '0px' && style.height == '0px') return false;

        // Check tabindex attribute
        const tabindex = valItem.getAttribute('tabindex');
        if (tabindex !== null && tabindex === '-1') return false;
    }

    return true;
}

function isInputReadonly(input) {
    return $(input).prop('readonly');
}

function isInputDisabled(input) {
    return $(input).prop('disabled');
}

function isPasswordOrConfirm(valItem) {
    return ['password', 'confirm_password', 'details__password_confirm', 'details__password'].includes(valItem.getAttribute('id'));
}

function isUsername(valItem) {
    return ['details__username'].includes(valItem.getAttribute('id'));
}

function isNameInput(valItem) {
    return ['firstname', 'lastname'].some(className => valItem.classList.contains(className));
}

function insertValidation(el, msg, countErrorFields, dynamicValidate) {
    let alreadyHasError = $(el).siblings('.validation_error').length > 0;

    if (alreadyHasError) {
        $(el).siblings('.validation_error').html(msg);
    } else {
        let er = document.createElement("span");
        er.className = "validation_error";
        er.innerHTML = msg;

        if (el.classList.contains("select2")) {
            $(el).parent().append(er.outerHTML);
            $(el).parent().addClass("error-input");
        } else if (el.getAttribute("name") === "termsaccept" || el.getAttribute("data-type") === "termsaccept") {
            $(er.outerHTML).insertAfter($(el).parent());
            $(el).parent().addClass("error-input");
        } else if (el.getAttribute("type") === "radio" || el.getAttribute("type") === "checkbox") {
			var parent = $(el).closest('.quote-question__radio-wrapper');
			
			if(parent.length > 0){
				alreadyHasError = $(parent).siblings('.validation_error').length > 0;

				if(!alreadyHasError){
					$(er.outerHTML).insertAfter(parent);
				}
			} else {
				$(er.outerHTML).insertAfter(el);
			}
        } else {
            $(er.outerHTML).insertAfter(el);
        }
    }

    $(el).siblings(".formatted").remove();
    $(el).closest(".a__addressFields").addClass("active");
    $(el).closest('.quote-question').addClass("input-status input-status--incorrect").removeClass("input-status--correct");
    $(el).addClass('error-input');

    if (countErrorFields === 0 && !dynamicValidate) {
        $("html, body").animate({
            scrollTop: $(el).offset().top - 300
        }, 0);
    }

    let message = "JS validation error for: " + el.getAttribute("name") + ", with the message: " + msg;
    window.mwConsoleLog(message);

    return ++countErrorFields;
}

// Luhn Algorithm
function validateLuhnAlgorithm(cardNumber) {
    let sum = 0;
    let isEven = false;
	let isCorrect = false;
	let cardType = 'unknown';
	
	cardNumber = cardNumber.replace(/\s/g, '');

    for (let i = cardNumber.length - 1; i >= 0; i--) {
        let digit = parseInt(cardNumber.charAt(i), 10);

        if (isEven) {
            digit *= 2;
            if (digit > 9) {
                digit -= 9;
            }
        }
        sum += digit;
        isEven = !isEven;
    }

    detectCardType(cardNumber);

    isCorrect = sum % 10 === 0;

	if(isCorrect) {
		cardType = detectCardType(cardNumber);

		if(cardType && $('#payment__number_type').length) {
			$('#payment__number_type').val(cardType);
		}
	}

	return isCorrect;
}

// Card Type Detection
function detectCardType(cardNumber) {
    const patterns = {
        visa: /^4[0-9]{12}(?:[0-9]{3})?$/,
        mc: /^5[1-5][0-9]{14}$/,
        amex: /^3[47][0-9]{13}$/,
        discover: /^6(?:011|5[0-9]{2})[0-9]{12}$/,
    };

    for (const cardType in patterns) {
        if (patterns[cardType].test(cardNumber)) {
            return cardType;
        }
    }

    return "Unknown";
}

// Expiration Date Validation
function validateExpirationDate(input) {
    const currentDate = new Date();
    const currentYear = Number(currentDate.getFullYear().toString().slice(-2));
    const currentMonth = currentDate.getMonth() + 1; // January is 0
	let [expirationMonth, expirationYear] = input.split('/');
	let isCorrect = false;

	let sanitisedExpirationMonth = Number(expirationMonth);
	let sanitisedExpirationYear = Number(expirationYear);

    if (sanitisedExpirationYear > currentYear) {
        isCorrect = true;
    } else if (sanitisedExpirationYear === currentYear && sanitisedExpirationMonth >= currentMonth) {
        isCorrect = true;
    }

	if (isCorrect && $("#payment__expiry_month").length && $("#payment__expiry_year").length) {
		$("#payment__expiry_month").val(expirationMonth.toString());
		$("#payment__expiry_year").val(expirationYear.toString());
	}

    return isCorrect;
}

// CVV/CVC Validation
function validateCVV(cvv) {
    const cvvPattern = /^[0-9]{3,4}$/;
    return cvvPattern.test(cvv);
}

function addDynamicValidation() {
	// This function has been refactored to use event delegation on the document,
	// which automatically handles inputs added to the DOM dynamically (e.g., via AJAX).
	// This single function call on document ready is sufficient.

	const doc = $(document);

	// --- FOCUSOUT: for text-like inputs that validate on blur ---
    const focusoutSelectors = [
        '.quote-question__card-number input',
        '.quote-question__conviction-code input',
        '.quote-question__dob input',
        '.quote-question__email input',
        '.quote-question__number input',
        '.quote-question__phone input',
        '.quote-question__password input',
        '.quote-question__postcode input',
        '.quote-question__security-code input',
        '.quote-question__text input'
    ].join(', ');

    doc.on('focusout', focusoutSelectors, function () {
        const $wrapper = $(this).closest('.quote-question');
        const $inputs = $wrapper.find('input, select');
        if ($inputs.filter('.skip').length === 0) {
            if ($(this).data('required')) {
                validateEntries($inputs, 0, true);
            }
        } else {
            removeValidation($inputs);
            $inputs.removeClass('skip');
        }
    });

    // --- Special delegated handler for license number ---
    doc.on('focusout', '.quote-question__license-number input', function () {
        const $wrapper = $(this).closest('.quote-question__license-number');
        const $licenseInputs = $wrapper.find('input[type=text]');

        // CRO variation: when the licence inputs are hidden ("No" selected), there's nothing
        // to validate — clear any stale licence results so they can't re-flag the question.
        if (!$licenseInputs.filter(':visible').length) {
            licenceNumberValid = {};
            return;
        }

        if ($(this).data('required') === true) {
            validateEntries($licenseInputs, 0, true);
        }
    });

    // --- Special delegated handlers for car registration ---
    doc.on('focusout', '.quote-question__car-reg input[type=checkbox]', function() {
        if ($(this).data('required')) {
            validateEntries($(this), 0, true);
        }
    });
    
    doc.on('change', '.quote-question__car-reg select', function() {
        if ($(this).data('required')) {
            validateEntries($(this), 0, true);
        }
    });

	// --- CHANGE: for inputs that validate on selection/value change ---
	const changeSelectors = [
		'.quote-question__additional-driver input[type=radio]:not(.quote-tooltip__input)',
		'.quote-question__boolean input[type=radio]:not(.quote-tooltip__input)',
		'.quote-question__dynamic-boolean input[type=radio]:not(.quote-tooltip__input)',
		'.quote-question__checkbox-legal input[type=checkbox]',
		'.quote-question__checkbox input[type=checkbox]',
		'.quote-question__country select',
		'.quote-question__date input',
		'.quote-question__date-time input',
		'.quote-question__dropdown:not(.quick-access) select',
		'.quote-question__expiry-date input',
		'.quote-question__radio input[type=radio]:not(.quote-tooltip__input)',
		'.quote-question__postcode select',
		'.quote-question__car-reg select',
	].join(', ');

	doc.on('change', changeSelectors, function () {
		const $wrapper = $(this).closest('.quote-question');
		const $inputs = $wrapper.find('input, select');
		if ($inputs.filter('.skip').length === 0) {
			if ($(this).data('required')) {
				validateEntries($inputs, 0, true);
			}
		} else {
			removeValidation($inputs);
			$inputs.removeClass('skip');
		}
	});

	// --- SELECT2: Special events for Select2 dropdowns ---
	doc.on('select2:select select2:unselect', '.quote-question__dropdown .select2-hidden-accessible', function () {
		if ($(this).data('required')) {
			validateEntries($(this), 0, true);
		}
	});
}

function restrictExpiryDate() {
    $(document).on('keypress', '#payment__expiry', function(event) {
        var code = event.keyCode || event.which;
        var allowedKeys = [8]; // Allow backspace

        // Only allow digits (0–9) and allowed keys
        if (allowedKeys.indexOf(code) === -1 && (code < 48 || code > 57)) {
            event.preventDefault();
            return;
        }

        // Existing formatting logic
        event.target.value = event.target.value.replace(
            /^([1-9]\/|[2-9])$/g, '0$1/' // 3 > 03/
        ).replace(
            /^(0[1-9]|1[0-2])$/g, '$1/' // 11 > 11/
        ).replace(
            /^([0-1])([3-9])$/g, '0$1/$2' // 13 > 01/3
        ).replace(
            /^(0?[1-9]|1[0-2])([0-9]{2})$/g, '$1/$2' // 141 > 01/41
        ).replace(
            /^([0]+)\/|[0]+$/g, '0' // 0/ > 0 and 00 > 0
        ).replace(
            /[^\d\/]|^[\/]*$/g, '' // To allow only digits and `/`
        ).replace(
            /\/\//g, '/' // Prevent entering more than 1 `/`
        );
    });
}

function restrictCreditCard() {
    $(document).on('input', '#payment__number', function(event) {
        var pos = this.selectionStart,
            val = this.value,
            // Remove all non-digit characters first
            digitsOnly = val.replace(/\D/g, ''),
            spc = (val.substr(0, pos).match(/\s/g) || []).length,
            len = digitsOnly.length,
            prv = this.prev != null ? this.prev : '',
            ins = prv != this.value,
            pad = Math.floor(len / 4),
            nex = '';

        if (ins) {
            // Build formatted string with spaces every 4 digits
            for (var i = 0; i <= pad; i++) {
                nex += digitsOnly.substr(i * 4, 4);
                if (pad !== 0 && pad !== i) {
                    nex += ' ';
                }
            }

            this.value = nex;

            var prevSpc = (val.substr(0, pos).match(/\s/g) || []).length,
                currSpc = (this.value.substr(0, pos).match(/\s/g) || []).length,
                newPos = pos + (currSpc - prevSpc);

            this.setSelectionRange(newPos, newPos);
        }

        this.prev = this.value;
    });
}

function restrictSecurityCode() {
    $(document).on('input', '#payment__code', function(event) {
        // Keep only digits in the input
        this.value = this.value.replace(/\D/g, '');
    });
}

function restrictName() {
    $(document).on('input', '#payment__name, #payment__firstname, #payment__surname, input.firstname, input.lastname', function(event) {
        // Allow only letters, spaces, apostrophes (') and dash (-)
        this.value = this.value.replace(/[^a-zA-Z'\s-]/g, '');
    });
}

function prefillCardholderDetails() {
	if ($("input[name=payment__prefill]").length) {
		$("input[name=payment__prefill]").on("change", function () {
			if ($(this).prop("checked")) {
				let prefillData = $(".payment__prefill-data"),
					toggleWrapper = $(".payment__prefill"),
					// [First Name] related data.
					fname = prefillData.data("fname"),
					inputFname = $("input[name=payment__firstname]"),
					// [Last Name] related data.
					lname = prefillData.data("lname"),
					inputLname = $("input[name=payment__surname]"),
					// [Email] related data.
					email = prefillData.data("email"),
					inputEmail = $("input[name=payment__email]"),
					// [Address Wrapper] related data.
					addressFields = $(".a__addressFields"),
					// [Address Line 1] related data.
					line1 = prefillData.data("line1"),
					inputLine1 = addressFields.find("input[name=line_1]"),
					// [Address Line 2] related data.
					line2 = prefillData.data("line2"),
					inputLine2 = addressFields.find("input[name=line_2]"),
					// [Address Line 3] related data.
					line3 = prefillData.data("line3"),
					inputLine3 = addressFields.find("input[name=line_3]"),
					// [Address Town] related data.
					town = prefillData.data("town"),
					inputTown = addressFields.find("input[name=town]"),
					// [Address Postcode] related data.
					postcodeWrapper = $(".details__postcode-wrapper"),
					postcode = prefillData.data("postcode"),
					inputPostcode = addressFields.find("input[name=post_code]");

				// hide and show all related fields.
				toggleWrapper.hide();
				postcodeWrapper.hide();
				addressFields.show();

				if (fname) {
					inputFname.val(fname).trigger("change");
                    validateEntries(inputFname, 0, true);
				}

				if (lname) {
					inputLname.val(lname).trigger("change");
                    validateEntries(inputLname, 0, true);
				}

				if (email) {
					inputEmail.val(email).trigger("change");
                    validateEntries(inputEmail, 0, true);
				}

				if (line1) {
					inputLine1.val(line1).trigger("change");
                    validateEntries(inputLine1, 0, true);
				}

				if (line2) {
					inputLine2.val(line2).trigger("change");
				}

				if (line3) {
					inputLine3.val(line3).trigger("change");
				}

				if (town) {
					inputTown.val(town).trigger("change");
                    validateEntries(inputTown, 0, true);
				}

				if (postcode) {
					inputPostcode.val(postcode).trigger("change");
                    validateEntries(inputPostcode, 0, true);
				}
			}
		});
	}
}

function addFormSubmitEventHandler(formIDs = []) {
    formIDs.forEach(function (id) {
        if (!$(id).length) return;

        // flags to control repeated submits
        let checkedPostcode = false;
        let submissionInProgress = false;

        $(document).on('submit', id, function (e) {
            const currentForm = $(this);
            let result;

            if (submissionInProgress) {
                // already running validation/submission logic
                return;
            }
            submissionInProgress = true;
            currentForm.addClass('loading');

            // -------------------------
            // #form-payment
            // -------------------------
            if (id === '#form-payment') {
                if ($('.postcode-select').val()) {
                    checkedPostcode = true;
                } else if ($(".postcode-select").is(':visible')) {
                    result = window.validateForm(currentForm);
                    if (!result) {
                        e.preventDefault();
                        currentForm.removeClass('loading');
                        submissionInProgress = false;
                        return;
                    }
                }

                if (!checkedPostcode && $("#details__postcode").is(':visible')) {
                    $('.postcode-btn').trigger('click');
                    e.preventDefault();
                    currentForm.removeClass('loading');
                    submissionInProgress = false;
                    return;
                }

                result = window.validateForm(currentForm);
                if (!result) {
                    e.preventDefault();
                    currentForm.removeClass('loading');
                    submissionInProgress = false;
                    return;
                }
            }

            // -------------------------
            // #form-your-details
            // -------------------------
            else if (id === '#form-your-details') {
                if ($('.postcode-select').val()) {
                    checkedPostcode = true;
                } else if ($(".postcode-select").length && $(".postcode-select").is(':visible')) {
                    result = window.validateForm(currentForm);
                    if (!result) {
                        e.preventDefault();
                        currentForm.removeClass('loading');
                        submissionInProgress = false;
                        window.mwConsoleLog('Postcode validation failed');
                        return;
                    }
                }

                if (!checkedPostcode && ($("#details__postcode").length && $("#details__postcode").is(':visible'))) {
                    $('.postcode-btn').trigger('click');
                    e.preventDefault();
                    currentForm.removeClass('loading');
                    submissionInProgress = false;
                    window.mwConsoleLog('Postcode not checked');
                    return;
                }

                result = window.validateForm(currentForm);
                window.mwConsoleLog('Form validation result: ' + result);
                if (!result) {
                    e.preventDefault();
                    currentForm.removeClass('loading');
                    submissionInProgress = false;
                    return;
                }

                if ($('#details__username').length) {
                    if (!submitYourPolicyForm) {
                        e.preventDefault();
                        currentForm.removeClass('loading');
                        submissionInProgress = false;
                        window.mwConsoleLog('Aggregator - flag not checked');
                        return;
                    }

                    if (!currentForm.hasClass('submission')) {
                        result = window.validateForm(currentForm);
                        if (result) {
                            currentForm.addClass('submission');
                        }
                    } else {
                        result = true;
                    }

                    if (!result) {
                        e.preventDefault();
                        currentForm.removeClass('loading');
                        submissionInProgress = false;
                        window.mwConsoleLog('Aggregator - Form validation failed');
                        return;
                    } else {
                        if (submitYourPolicyForm && !checkedYourPolicyForm) {
                            checkedYourPolicyForm = true;
                            currentForm.off('submit').submit();
                            window.mwConsoleLog('Aggregator - Submitting Your Policy Form');
                            return;
                        }
                    }
                }
            }

            // -------------------------
            // #form-your-policy
            // -------------------------
            else if (id === '#form-your-policy' && !checkedYourPolicyForm) {
                if ($('#details__username').length) {
                    if ($('#details__username').val() && $('#details__username').prop('readonly')) {
                        window.mwConsoleLog('Your Policy Form - Username is readonly, skipping validation and setting submitYourPolicyForm=true');
                        submitYourPolicyForm = true;
                    }
                } else {
                    window.mwConsoleLog('Your Policy Form - Username is not present, skipping validation and setting submitYourPolicyForm=true');
                    submitYourPolicyForm = true;
                }

                if (!submitYourPolicyForm) {
                    e.preventDefault();
                    currentForm.removeClass('loading');
                    submissionInProgress = false;
                    yourPolicySubmitAttempted = true;
                    window.mwConsoleLog('Your Policy Form not submitted - flag not checked');
                    return;
                }

                if (!currentForm.hasClass('submission')) {
                    result = window.validateForm(currentForm);
                    if (result) {
                        currentForm.addClass('submission');
                    }
                } else {
                    result = true;
                }

                if (!result) {
                    e.preventDefault();
                    currentForm.removeClass('loading');
                    submissionInProgress = false;
                    window.mwConsoleLog('Your Policy Form validation failed');
                    return;
                } else {
                    if (submitYourPolicyForm && !checkedYourPolicyForm) {
                        checkedYourPolicyForm = true;
                        currentForm.off('submit').submit();
                        window.mwConsoleLog('Your Policy Form submitted, setting checkedYourPolicyForm=true');
                        return;
                    }

                    let isRenewal = getQueryVariable('renewal') || getCookieValue('renewal');
                    if (isRenewal) {
                        checkedYourPolicyForm = true;
                        currentForm.off('submit').submit();
                        window.mwConsoleLog('Your Policy Form submitted for renewal, setting checkedYourPolicyForm=true');
                        return;
                    }
                }
            }

            // -------------------------
            // #mta
            // -------------------------
            else if (id === '#mta') {
                let findCarButton = $('.car__registration-find');
                if (findCarButton && isVisible(findCarButton, true)) {
                    findCarButton.trigger('click');
                    result = window.validateForm(currentForm);
                    if (!result) {
                        e.preventDefault();
                        currentForm.removeClass('loading');
                        submissionInProgress = false;
                        return;
                    }
                }
            }

            // -------------------------
            // All other forms
            // -------------------------
            else {
                result = window.validateForm(currentForm);
                if (!result) {
                    e.preventDefault();
                    currentForm.removeClass('loading');
                    submissionInProgress = false;
                    return;
                }
            }

            // If we reach here, form passes validation
            submissionInProgress = false;
        });
    });
}

function restrictDatetimeInputLength() {
    $(document).on('input', 'input[type=datetime-local]', function () {
        const value = $(this).val();
        const match = value.match(/^(\d{4})\d*/);
    
        if (match && value.length > 4) {
          const parts = value.split('T');
          let date = parts[0];
          let time = parts[1] || '';
    
          // Keep only first 4 digits in the year
          const correctedDate = date.replace(/^(\d{4})\d*/, '$1');
          $(this).val(correctedDate + (time ? 'T' + time : ''));
        }
    });
}

function restrictCustomerID() {
    $(document).on('input', 'input.customer-id__input', function () {
        this.value = this.value.replace(/\D/g, '');
    });
}

function restrictRegistrationInput() {
    $(document).on('input', 'input[name*=details__additional_vehicle_number]', function () {
        let sanitized = this.value.replace(/[^a-zA-Z0-9]/g, '').toUpperCase();

        this.value = sanitized;
    });
}

function triggerNext() {
    if($('input[name=trigger-next]').val()) {
        $('input[name=about__privacy_policy_confirm]').prop('checked', true).trigger('change');
        $('button[name=go-forward-stage--your-policy]').trigger('click');
    }
}

$(function () {
	let formIDs = [
		'#form-your-car', 
		'#form-your-details', 
		'#form-your-policy', 
		'#form-your-addons', 
        '#form-policy-information',
		'#form-payment',
        '#mta_form',
        '#mta',
	];

    addFormSubmitEventHandler(formIDs);
	
	$('form[data-valid="true"]').on('submit', function(e) {
        let $form = $(this);

        // Check if the form has any of the invalid classes
        let isInvalid = formIDs.some(function(className) {
            return $form.is(className);
        });

        if (!isInvalid) {

            let result = window.validateForm($(this));  

            if(!result) {
                e.preventDefault();
            } else {
                return true;
            }
        } 
	});

	addDynamicValidation();

    restrictExpiryDate();

    restrictCreditCard();

    restrictSecurityCode()

    restrictName();

    // make sure we only run our JS code within the correct template page.
	if ($(document).find(".collingwood-api").length) {
		prefillCardholderDetails();
	}

    restrictDatetimeInputLength();

    restrictCustomerID();

    restrictRegistrationInput();

    // triggerNext();
});